/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBoxV = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M21 4v2h-2v2h3v10h-3v2h2v2h-6v-2h2v-2h-3V8h3V6h-2V4zM9 2v2H7v2h3v10H7v2h2v2H3v-2h2v-2H2V6h3V4H3V2zm11 12h-4v2h4zM8 12H4v2h4zm12-2h-4v2h4zM8 8H4v2h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartBoxV as ChartBoxV };
